export const toCamelCase = (str: string) => {
  return str
    .replace(/\s(.)/g, (match, letter) => letter.toUpperCase()) // Capitalize letters after spaces
    .replace(/\s+/g, '') // Remove all spaces
    .replace(/^(.)/, (match, letter) => letter.toLowerCase()); // Lowercase the first letter
};